
import "./style.css";
import React, {useState, useEffect} from 'react';
import { Grid, Typography, Button,TextareaAutosize, Box, Dialog, LinearProgress, DialogContent,Card, CardContent, CardActions, Checkbox, Select, MenuItem, FormControlLabel, Switch } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import axios from "axios";
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import {useNavigate} from "react-router-dom";


const Step5CallCenter = (props) => {
  const [focus, setFocus] = useState();
  const navigate = useNavigate();

  const handleSebelumPPN = (event) => {
    if(focus==="sebelumPPN"){
    setkontrakSub(event.target.value)
    setkontrakGrand(Math.floor(event.target.value*(1+(ppnPercent/100))))
    setDiscPercent(Math.floor((nominalDisc/event.target.value)*10000)/100);
    setSubDiskon(Math.floor((event.target.value-nominalDisc)*100)/100);
    setGrandDiskon(Math.floor((event.target.value-nominalDisc)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
  }
const handleSetelahPPN = (event) => {
  if(focus==="setelahPPN"){
  setkontrakGrand(event.target.value)
  setkontrakSub(Math.floor(event.target.value*(1-(ppnPercent/100))))
  
  setDiscPercent(Math.floor((nominalDisc/(Math.floor(event.target.value*(1-(ppnPercent/100)))))*10000)/100);
  setSubDiskon(Math.floor(((Math.floor(event.target.value*(1-(ppnPercent/100))))-nominalDisc)*100)/100);
  setGrandDiskon(Math.floor(((Math.floor(event.target.value*(1-(ppnPercent/100))))-nominalDisc)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
}

  const [hargaDiskon, sethargaDiskon] = useState();
  const [categorias, setCategorias] = useState([]);
  const [paidDate, setpaidDate] = useState(new Date());
  const [salesoption,setSalesOption] =useState(null)
  const [alamatKontrak, setalamatKontrak] = useState(null);
  const handleChangeAddress = (event) => {
    setalamatKontrak(event.target.value)
  }
    const handleDateChange = (date) => {
        setpaidDate(date);
        const piDate = date.getDate();
        const longMonth = date.toLocaleString('default', { month: 'long' });
        const piYear = date.getFullYear();
        console.log(piDate + " " + longMonth + " " + piYear);
    }
    const shout = () => {

    }
    const [selectedPackage, setSelectedPackage] = useState(null);
    const getSelectedPackageTitle = () => {
        switch (selectedPackage) {
          case 0:
            return 'Virtual Office';
          case 1:
            return 'Private Office';
          // Add more cases for other package indices
          default:
            return '';
        }
      };
    const [searchThis, setsearchThis] = useState();
    const searchSelected = () => {

    } 

    
    const getCategorias = async () => {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
      }).then(response=>{
        setCategorias(response.data.pilihanAlamat);
    });
      //console.log(res);
    }
    useEffect(() => {
        getCategorias();})
const [notes,setNotes]=useState()
const [durasiKontrak, setdurasiKontrak] = useState(1);
const [unitDurasiKontrak, setunitDurasiKontrak] = useState("Tahun");
const [kontrakSub, setkontrakSub] = useState();
const [discStatus, setDiscStatus] = useState("No")
const [kontrakPPN, setkontrakPPN] = useState();
const [kontrakGrand, setkontrakGrand] = useState();
const [diskon, setDiskon] = useState();
const [tipeCall, setTipeCall] = useState();
const [ppnPercent,setppnPercent] = useState(parseInt("11%"));
const handleppnPercent = (event) => {
  if(focus==="PPN"){

  setppnPercent(parseInt(event.target.value));
  setkontrakGrand(Math.floor(kontrakSub*(1+(parseInt(event.target.value)/100))))
  
  setDiscPercent(Math.floor((nominalDisc/kontrakSub)*10000)/100);
    setSubDiskon(Math.floor((kontrakSub-nominalDisc)*100)/100);
    setGrandDiskon(Math.floor(((kontrakSub-nominalDisc)*(1+(parseInt(event.target.value)/100)))*10)/10);
  
  }
}
const [nominalDisc, setNominalDisc] = useState();
const handleNominalDisc = (event) => {
  if(focus ==="nominalDisc"){
    console.log("here")
    setNominalDisc(event.target.value)
    setDiscPercent(Math.floor((event.target.value/kontrakSub)*10000)/100);
    setSubDiskon(Math.floor((kontrakSub-event.target.value)*100)/100);
    setGrandDiskon(Math.floor((kontrakSub-event.target.value)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }

}

const [DiscPercent, setDiscPercent] = useState();

const handleDiscPercent = (event) => {
  if(focus ==="DiscPercent"){
    setDiscPercent(event.target.value);
    setNominalDisc((parseInt(event.target.value)/100)*kontrakSub);
    setSubDiskon(Math.floor(kontrakSub-((parseInt(event.target.value)/100)*kontrakSub)*100)/100);
    setGrandDiskon(Math.floor((kontrakSub-((parseInt(event.target.value)/100)*kontrakSub))*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
}

const [subDiskon, setSubDiskon] = useState();
const handleSubDiskon = (event) => {
  if(focus === "subDiskon"){

  setSubDiskon(event.target.value)
  setNominalDisc(kontrakSub-event.target.value)
  setDiscPercent(Math.floor(((kontrakSub-event.target.value)/kontrakSub)*10000)/100);
  setGrandDiskon(Math.floor(event.target.value*(1+(parseInt(ppnPercent)/100))*100)/100);
}
}

const [grandDiskon, setGrandDiskon] = useState();
const handleGrandDiskon = (event) => {
  if(focus === "grandDiskon"){
    setGrandDiskon(event.target.value)
    setSubDiskon(Math.floor(event.target.value/(1+(parseInt(ppnPercent)/100))*100)/100)
    setDiscPercent(Math.floor(((kontrakSub-(event.target.value/(1+(parseInt(ppnPercent)/100))))/kontrakSub)*10000)/100);
    setNominalDisc(Math.floor((kontrakSub-(event.target.value/(1+(parseInt(ppnPercent)/100))))))

  }
}
const [unitMeetingKontrak, setunitMeetingKontrak] = useState("jam /Tahun");
const [selectedPaketVO, setselectedPaketVO] = useState();
const [loadVisibility, setLoadVisibility] = useState(false);
const [state, setState] = useState({
  gilad: false,
  jason: false,
  antoine: true,
});
const switchChange = (event) => {
  setState({
    ...state,
    [event.target.name]: event.target.checked,
  });
  if(discStatus === "No"){
    setDiscStatus("Yes")
  }else{
    setDiscStatus("No")
    setNominalDisc();
    setDiscPercent();
    setSubDiskon();
    setGrandDiskon();
  }
}
const [sellerID, setSellerID] = useState("PT. Supardi Nethanel Husain");
const [hargaStat,setHargaStat] =useState("Tunjukkan")

    const handlePackageClick = (index) => {
        setSelectedPackage(index);
      };
    if (props.currentStep !== 5 || props.selectedType !== "Call Center") {
        return null;
      }

      const saveKontrak = () => {
        if (!salesoption) {
          alert("Pilih Sales");
          return;
        }
        setLoadVisibility(true)
        console.log(props)
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestKontrakNum`)
        .then(response => {
          console.log(response.data);
          console.log(response.data.jumlah);
          var testestest = response.data.jumlah;
          console.log(testestest);
          var piAmountNow = parseInt(testestest) + 1;
          console.log(piAmountNow);
          var piMonth = new Date(props.selectedPost.tanggalAwal).getMonth() + 1
          var piYear = new Date(props.selectedPost.tanggalAwal).getYear() + 1900
          var piDate = new Date(props.selectedPost.tanggalAwal).getDate()
          var PINumbnow = piYear + "." + piMonth + "-Kontrak-Zanio." + piAmountNow;
          console.log({ PINumbnow, piAmountNow });
        
          return axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveKontrakCallCenter`, {
            props, piAmountNow, PINumbnow, notes, sellerID, hargaStat, salesoption
          })
          .then(response => {
            console.log(response.data._id)
            const kontrakid = response.data._id; // extract _id from response
            console.log("Ini PINUMBNOW yang mau di render "+PINumbnow)
            return axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakCallCenter`, {
              kontrakid, props, piAmountNow, PINumbnow, notes, sellerID, hargaStat // include _id here
            }, {
              responseType: "blob"
            });
          })
          .then(resp => {
            console.log(resp)
            const blob = new Blob([resp.data], { type: 'application/pdf' })
            var fileURLNew = URL.createObjectURL(blob);
            console.log(fileURLNew)
            setLoadVisibility(false)
            window.open(fileURLNew, '_blank');
            navigate("/Kontrak")
          });
        }).catch(error => {
          console.error(error);
          setLoadVisibility(false)
        });
      }
      
      
      const renderPackageCard = (index, title, disabled = false) => (
        <Card
          onClick={disabled ? null : () => handlePackageClick(index)}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: selectedPackage === index ? 'primary.main' : 'divider',
            borderWidth: 1,
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <CardContent>
            <Typography variant="h5">{title}</Typography>
          </CardContent>
          {selectedPackage === index && !disabled && (
            <CardActions>
              <CheckCircleOutlineIcon color="primary" />
            </CardActions>
          )}
        </Card>
      );
    return (<Grid container>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Typography sx={{mb:2}}>Review Data dibawah</Typography>
                <Grid xs={12} sx={{mb:5}} container>
                  <Select value={sellerID} onChange={event => setSellerID(event.target.value)}><MenuItem value="PT. Kendali Mitra Sukses">PT. Kendali Mitra Sukses</MenuItem><MenuItem value="PT. Supardi Nethanel Husain">PT. Supardi Nethanel Husain</MenuItem></Select>
                </Grid>
                <Grid xs={12} sx={{mb:5}} container>
                  <Grid xs={2} sx={{mb:5}} item>
                  <Typography>Status Harga:</Typography>
                  </Grid>
                  <Select value={hargaStat} onChange={event => setHargaStat(event.target.value)}><MenuItem value="Sembunyikan">Sembunyikan</MenuItem><MenuItem value="Tunjukkan">Tunjukkan</MenuItem></Select>
                </Grid>
                <Grid xs={12} sx={{mb:5}} container>
                  <Grid xs={2} sx={{mb:5}} item>
                  <Typography>Pilih Sales: </Typography>
                  <Typography style={{ color: 'grey' }}>Menurut data sepertinya: {props?.selectedPost?.invoicetoLink?.Inquiry?.Sales?? "N/A"}. Namun apakah benar?</Typography>
                  </Grid>
                  <Select value={salesoption} onChange={event => setSalesOption(event.target.value)}><MenuItem value="Adnan">Adnan</MenuItem><MenuItem value="Felly">Felly</MenuItem><MenuItem value="Dinda">Dinda</MenuItem><MenuItem value="Diva">Diva</MenuItem><MenuItem value="Reinner">Reinner</MenuItem><MenuItem value="Lainnya">Lainnya</MenuItem></Select>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Nama Klien:</Typography>
                  <Typography>{props.selectedPost.client.data[0].Nama}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Nama Company:</Typography>
                  <Typography>{props.selectedPost.company?.data[0]?.namaPerusahaan}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Nomor Telepon Sewa:</Typography>
                  <Typography>{props.selectedPost.nomorTeleponSewa}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Tipe Forwarding:</Typography>
                  <Typography>{props.selectedPost.tipeForwarding}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Tipe Answering:</Typography>
                  <Typography>{props.selectedPost.tipeAnswering}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Tipe Telepon:</Typography>
                  <Typography>{props.selectedPost.tipeTelepon}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Tanggal Awal Kontrak:</Typography>
                  <Typography>{props.selectedPost.tanggalAwal.toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' }).replace(/(\w+) (\d+), (\d+)/, '$2 $1 $3')}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Tanggal Akhir Kontrak:</Typography>
                  <Typography>{props.selectedPost.tanggalAkhir.toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' }).replace(/(\w+) (\d+), (\d+)/, '$2 $1 $3')}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Kuota Meeting Room:</Typography>
                  <Typography>{props.selectedPost.durasiMeeting} {props.selectedPost.unitMeetingKontrak}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Metode Pembayaran:</Typography>
                  <Typography>Setiap {props.selectedPost.paymentTerms} {props.selectedPost.paymentTermsUnit}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Pulsa:</Typography>
                  <Typography>{props.selectedPost.pulsa}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Harga Sub:</Typography>
                  <Typography>{props.selectedPost.subTotalKontrak} /{props.selectedPost.unitHargaKontrak}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Harga Grand:</Typography>
                  <Typography>{props.selectedPost.grandTotalKontrak} /{props.selectedPost.unitHargaKontrak}</Typography>
                </Grid>
                <Grid xs={12} container>
                  <Typography sx={{mr:2}}>Harga Discount:</Typography>
                  <Typography>{props.selectedPost.grandDiskon} /{props.selectedPost.unitHargaKontrak}</Typography>
                </Grid>
                <Grid sm={12} sx={{ mt:10, mb:10 }}fontSize="14px" >
                                <p>Notes Tambahan:</p>
                                <TextareaAutosize  style={{ minHeight:"200px", width: "100%" }} value={notes} onChange={event => setNotes(event.target.value)} />
                        </Grid>
                <Button onClick={() =>{saveKontrak()}}>Save and Print</Button>
                           
    </Grid>);};

    export default Step5CallCenter;
